import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Divider,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PlanDetailsProps } from './PlanForm';

interface PlanCardProps {
  plan: PlanDetailsProps;
  duration: string;
  actions?:
    | {
        label: string;
        color?: 'primary' | 'secondary' | 'error';
        onClick: () => void;
      }[]
    | undefined;
  highlight?: boolean; // e.g., Growth+ plan
}

export const PlanCard: React.FC<PlanCardProps> = ({
  plan,
  duration,
  actions,
  highlight = false,
}) => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        bgcolor: highlight ? 'rgba(76, 175, 80, 0.08)' : 'white',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          p: 0,
        }}
      >
        {/* Header */}
        <Box sx={{ backgroundColor: '#CAE2FF', p: 2 }}>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h4" fontWeight="bold">
              {plan.name}
            </Typography>
            {/* {savings && (
                            <Typography variant="h3" color="text.secondary">
                                {savings}
                            </Typography> */}
            {/* )} */}
          </Box>

          {/* Price */}
          <Typography variant="h1" fontWeight="bold">
            $
            {
              plan.pricings.find(
                ({ duration }: { duration: string }) => duration === duration
              )?.price
            }
            <Typography component="span" variant="h4">
              /{duration}
            </Typography>
          </Typography>

          <Typography variant="body2" color="text.secondary" gutterBottom>
            {plan.description}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {/* Features */}
        <Box
          component="ul"
          sx={{
            listStyle: 'none',
            pl: 0,
            mb: 2,
            flexGrow: 1,
            p: 2,
          }}
        >
          {plan.features.map((f: any, i) => (
            <Box
              key={i}
              component="li"
              sx={{
                display: 'flex',
                alignItems: 'center',
                py: 1,
                borderBottom:
                  i !== plan.features.length - 1 ? '1px solid #f0e6f8' : 'none',
              }}
            >
              {/* Left tick */}
              <CheckCircleIcon sx={{ color: 'green', fontSize: 20, mr: 1 }} />

              {/* Feature text (takes remaining space) */}
              <Typography
                variant="h5"
                sx={{
                  flexGrow: 1,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {f.name}
              </Typography>

              {/* Limit aligned right */}
              <Typography variant="h5">{f.max_limit || ''}</Typography>
            </Box>
          ))}
        </Box>

        {/* CTA */}

        <Box
          px={3}
          pb={1}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            columnGap: 2,
          }}
        >
          {(actions || []).length > 0 &&
            actions?.map((action: any) => (
              <Button
                fullWidth
                variant="contained"
                color={action.color || 'primary'}
                onClick={(e) => action.onClick(e, { plan })}
              >
                <Typography variant="h5">{action.label}</Typography>
              </Button>
            ))}
        </Box>
      </CardContent>
    </Card>
  );
};
